<template>
  <transition name="alert" :duration="500">
    <div class="alert" ref="alert" @keydown.esc="close" v-if="open">
      <div class="alert__overlay" @click="close"></div>
      <div class="alert__content" ref="content" :style="{ left: offset.left, top: offset.top }">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
  import debounce from 'lodash.debounce'

  export default {
    props: {
      duration: { type: Number, default: 500 },
      open: { type: Boolean, default: false }
    },
    data () {
      return {
        offset: { left: 0, top: 0 }
      }
    },
    created () {
      this.calc = debounce(this.calc, 100)
    },
    watch: {
      open (value) {
        if (value) {
          this.calc()
          this.$nextTick(() => this.$refs.alert.addEventListener('resize', this.calc))
        } else {
          this.$refs.alert.removeEventListener('resize', this.calc)
        }

      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      calc () {
        let style = getComputedStyle(this.$refs.content)
        const w = style.width.split('px')[0]
        const h = style.height.split('px')[0]
        const vw = this.$el.offsetWidth
        const vh = this.$el.offsetHeight
        const left = w < vw ? (vw - w) / 2 : 0
        const top = h < vh ? (vh - h) / 2 : 0
        this.offset.left = `${left}px`
        this.offset.top = `${top}px`
      }
    }

  }
</script>

<style lang="scss">
  .alert {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .alert__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(#000, 0.85);
    transition: 0.25s opacity;
  }
  .alert__content {
    position: fixed;
    background: $color-navy;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.35s opacity 0.15s, 0.35s transform 0.15s;

    @include more(scale) {
      width: 600px;
      padding: 60px;
    }
    @include less(tablet) {
      max-width: 400px;
      padding: 20px;
    }
  }

  .alert-enter-active {
    .alert__overlay {
      opacity: 0;
    }
    .alert__content {
      opacity: 0;
      transform: scale(0.8, 0.8);
    }
  }
  .alert-enter-to {
    .alert__overlay {
      opacity: 1;
    }
    .alert__content {
      opacity: 1;
      transform: scale(1, 1);
    }
  }
  .alert-leave {
    .alert__overlay {
      opacity: 1;
    }
    .alert__content {
      opacity: 1;
      transform: scale(1, 1);
    }
  }
  .alert-leave-active {
    .alert__overlay {
      opacity: 0;
    }
    .alert__content {
      opacity: 0;
      transform: scale(0.8, 0.8);
    }
  }
</style>
